import { Tab, Tabs, List } from 'vant'
import ajaxUtil from 'cy_static/ajaxUtil'
import CardOfArticle from './CardOfArticle'
import { reqCyGetPoints } from 'changyo-public-api'
import cookie from 'js-cookie'

export default {
  name: 'WaterfallTabHJF',

  props: {
    isApiDataLoaded: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      category: [],
      pageSize: 20,
      categoryInfo: [],
      userPointsInfo: 0,
      leftHeight: 0,
      rightHeight: [],
      recommendPage: 1,  //推荐页总数
      con_value: '',
      startPage: 1,
      initPage:1,
      arr: [],
      a: true
    }
  },

  components: {
    Tab,
    Tabs,
    List,
    CardOfArticle
  },

  mounted() {
    this.getPoints()
  },
  // watch(){
  //   cookie.get('login_token'): function (cookie.get('login_token')) {
  //     console.log("activeId3 " + activeId3)
  //     // this.init(this.activeLeftIndex,this.activeRightIndex)
  //   },

  // },

  methods: {
    async getScroll(event) {
      // 滚动条距离底部的距离scrollBottom
      let scrollBottom =
        event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight;
      if(scrollBottom <= 300){
        const categoryData = this.category[this.categoryInfo[1]]
        if (!categoryData.finished) {
          categoryData.loading = true
          if(this.recommendPage == 1){
            await this._getItems(categoryData.minAmount, categoryData.maxAmount, ++categoryData.curPage, categoryData.categoryName)
          } else {
            // 当为推荐时, ++随机数   +到最大页码时,再从从头+到随机数
            if(categoryData.categoryName === '推荐') {
              if(this.startPage !== this.recommendPage){
                if(this.startPage + 1 !== this.initPage) {
                  await this._getItems(categoryData.minAmount, categoryData.maxAmount, ++this.startPage, categoryData.categoryName)
                } else {
                  categoryData.finished = true
                }
                // await this._getItems(categoryData.minAmount, categoryData.maxAmount, ++this.startPage, categoryData.categoryName)
              } else {
                this.startPage = 0
              }
            } else {
              //其他情况正常 ++page
              await this._getItems(categoryData.minAmount, categoryData.maxAmount, ++categoryData.curPage, categoryData.categoryName)
            }

          }
          categoryData.loading = false
        }
      }
    },
    _getCategory() {
      // const cacheData = sessionStorage.getItem('CHANGYO_HOME_WATERFALL_CATEGORY')

      const init = data => {
        this.categoryInfo[0] = data[0].categoryId
        this.categoryInfo[1] = 0
        this.category = data.map(item => {
          return {
            ...item,

            // 当前页
            curPage: this.startPage,

            // 左侧数据
            leftData: [],

            allData: [],

            // 右侧数据
            rightData: [],

            // 是否加载中
            loading: false,

            // 是否最后一页
            finished: false,

            // 每页加载情况
            pageLoaded: {}
          }
        })
      }

      init([{
        categoryName: '推荐',
        minAmount: 0,
        maxAmount: 0
      },
      {
        categoryName: '2千分以下',
        minAmount: 0,
        maxAmount: 2000
      },
      {
        categoryName: '2千-1万',
        minAmount: 2001,
        maxAmount: 10000
      },
      {
        categoryName: '1万-3万',
        minAmount: 10001,
        maxAmount: 30000
      },
      {
        categoryName: '3万-5万',
        minAmount: 30001,
        maxAmount: 50000
      },
      {
        categoryName: '5万-8万',
        minAmount: 50001,
        maxAmount: 80000
      },
      {
        categoryName: '8万以上',
        minAmount: 80001,
        maxAmount: 999999999999999
      }])

    },
    // 获取配置项的值
    async getAllocation() {
      ajaxUtil.loadData('/pgate/pointgate/service/config/getSystemConfig', {
        method: 'POST',
        // standard: 'standard',
        body:{
          con_key: 'T_jifen'
        }
      }).then(res => {
        if (res.respCode === '0000') {
          const minAmount = this.userPointsInfo - res.data.con_value < 0 ? 0 : this.userPointsInfo - res.data.con_value
          const maxAmount = this.userPointsInfo + Number(res.data.con_value)

          this.con_value = res.data.con_value
          // 初次获取推荐随机数的范围
          ajaxUtil.loadData('/goods/api/spu/searchSpu', {
            method: 'POST',
            standard: 'standard',
            body: {
              order: '1',
              channel: 'Changyoyo_Life_Central',
              minAmount: this.userPointsInfo - res.data.con_value < 0 ? 0 : this.userPointsInfo - res.data.con_value,
              maxAmount: this.userPointsInfo + Number(res.data.con_value),
              page: 1,
              rows: this.pageSize,
              platform: 'h5'
            }
          }).then(res => {
            if (res.respCode === '0000') {
              this.isApiDataLoaded()
              this.recommendPage = res.data.totalPages  // 推荐随机数的值
              this.startPage = Math.ceil(Math.random()*this.recommendPage)
              this.startPage = this.startPage === 0 ? 1 : this.startPage
              this.initPage = this.startPage
              this._getCategory()
              this.category[0].minAmount = minAmount
              this.category[0].maxAmount = maxAmount
              this._getItems( minAmount, maxAmount, this.category[0].curPage, this.category[0].categoryName)
            }
          })
        }
      })
    },
    toHJFSearch() {
      this.$router.push('/hjfSearch')
    },
    async getPoints() {
      const res = await reqCyGetPoints({ login_token: cookie.get('login_token') }).catch(err => console.log(err))
      if (res && res.data) {
        this.userPointsInfo = res.data.points
        this.getAllocation()
      }
    },

    async _getItems(minAmount, maxAmount, page, categoryName, type) {

      const categoryItem = this.category.find(item => item.categoryName === categoryName)

      const work = items => {
        if (!items) {
          categoryItem.finished = true
          return
        }
        if (page > this.recommendPage) {
          categoryItem.finished = true
        }
        // 切换tab清除重复数据
        if (type === 'change') {
          categoryItem.leftData = []
          categoryItem.rightData = []
        }
        items.forEach((item, index) => {
          // categoryItem.allData.push(item)

          if (index % 2 === 0) {
            categoryItem.leftData.push(item)
          } else {
            categoryItem.rightData.push(item)
          }
        })

        categoryItem.pageLoaded[page] = true
      }

        ajaxUtil.loadData('/goods/api/spu/searchSpu', {
          method: 'POST',
          standard: 'standard',
          body: {
            order: '1',
            channel: 'Changyoyo_Life_Central',
            minAmount,
            maxAmount,
            page,
            rows: this.pageSize,
            platform: 'h5'
          }
        }).then(res => {
          if (res.respCode === '0000') {
            this.isApiDataLoaded()
            // work(res.data.content)
            this.recommendPage = res.data.totalPages
            this.arr=[]
            // 过滤掉 固定现金加积分支付得商品
            res.data.content.forEach((item, index) => {
              if(item.payType === 'points' || item.payType === 'cash' || item.payType === 'cust'){
                this.arr.push(item)
              }
            })
            work(this.arr)
          } else {
            work(null)
          }
        })
    },

    async onChange(categoryInfo) {
      const data = categoryInfo.split('_')
      const categoryData = this.category[data[1]]
      const stickyEl = document.querySelector('.van-sticky--fixed')
      const type = 'change'
      categoryData.curPage = 1 //切换到其他价格区间,page从1开始

      if (!categoryData.finished) {
        categoryData.loading = true
        await this._getItems(categoryData.minAmount, categoryData.maxAmount, categoryData.curPage, categoryData.categoryName, type)
        categoryData.loading = false
      }

      // if (stickyEl) {
        // const _stickyEl = document.querySelector('.van-tabs')
        // document.querySelector('.homepage').scrollTop = _stickyEl.offsetTop
      // }

      this.categoryInfo = data
    }
  }
}
